import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, SlidersHorizontal, Download, ExternalLink } from 'lucide-react';
import { decisions, statutLabels } from '../data/mockData';
import './Decisions.css';

const juridictions = ['Toutes', 'TPI Abidjan', "Cour d'Appel Abidjan", 'TPI Bouaké', 'TPI Yamoussoukro'];
const statuts = ['Tous', 'a_verifier', 'anonymise', 'publie', 'brouillon', 'valide'];

const Decisions: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedJuridiction, setSelectedJuridiction] = useState('Toutes');
  const [selectedStatut, setSelectedStatut] = useState('Tous');

  const filtered = decisions.filter(d => {
    const matchSearch = searchQuery === '' ||
      d.numero.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.parties.toLowerCase().includes(searchQuery.toLowerCase()) ||
      d.nature.toLowerCase().includes(searchQuery.toLowerCase());
    const matchJuridiction = selectedJuridiction === 'Toutes' || d.juridiction === selectedJuridiction;
    const matchStatut = selectedStatut === 'Tous' || d.statut === selectedStatut;
    return matchSearch && matchJuridiction && matchStatut;
  });

  return (
    <div className="decisions-page">
      {/* Filters bar */}
      <div className="decisions-filters">
        <div className="decisions-search">
          <Search size={16} className="decisions-search-icon" />
          <input
            type="text"
            placeholder="Rechercher par numéro, parties, nature..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="decisions-filter-group">
          <select
            value={selectedStatut}
            onChange={(e) => setSelectedStatut(e.target.value)}
            className="decisions-select"
          >
            {statuts.map(s => (
              <option key={s} value={s}>
                {s === 'Tous' ? 'Tous les statuts' : statutLabels[s]?.label || s}
              </option>
            ))}
          </select>

          <select
            value={selectedJuridiction}
            onChange={(e) => setSelectedJuridiction(e.target.value)}
            className="decisions-select"
          >
            {juridictions.map(j => (
              <option key={j} value={j}>{j === 'Toutes' ? 'Toutes les juridictions' : j}</option>
            ))}
          </select>

          <button className="btn-filter">
            <SlidersHorizontal size={14} /> Avancé
          </button>
        </div>
      </div>

      {/* Results header */}
      <div className="decisions-results-header">
        <span className="decisions-count">{filtered.length} résultat{filtered.length > 1 ? 's' : ''}</span>
        <button className="btn-export">
          <Download size={14} /> Exporter CSV
        </button>
      </div>

      {/* Table */}
      <div className="decisions-table-wrapper">
        <table className="decisions-table">
          <thead>
            <tr>
              <th>N° Décision</th>
              <th>Juridiction</th>
              <th>Nature</th>
              <th>Parties</th>
              <th>Date</th>
              <th>Statut</th>
              <th>Agent</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(d => {
              const s = statutLabels[d.statut];
              return (
                <tr key={d.id}>
                  <td className="td-numero">{d.numero}</td>
                  <td>{d.juridiction}</td>
                  <td>{d.nature}</td>
                  <td className="td-parties">{d.parties}</td>
                  <td>{new Date(d.date).toLocaleDateString('fr-FR')}</td>
                  <td>
                    <span className="status-badge" style={{ color: s.color, background: s.bg }}>
                      {s.label}
                    </span>
                  </td>
                  <td>{d.agent}</td>
                  <td>
                    <button
                      className="btn-open"
                      onClick={() => navigate(`/espace-cndj/decisions/${d.id}`)}
                    >
                      <ExternalLink size={14} /> Ouvrir
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {filtered.length === 0 && (
          <div className="decisions-empty">
            Aucune décision ne correspond aux critères de recherche.
          </div>
        )}
      </div>
    </div>
  );
};

export default Decisions;
